import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { TradeLicense } from '../interfaces/models/trade-license';

@Injectable({
  providedIn: 'root'
})
export class TradeLicenseService {
  constructor(private http: HttpClient) {}

  saveTradeLicense(
    VendorId: number,
    TradeLicense: TradeLicense,
    query = {}
  ): Observable<any> {
    return this.http.post(
      `/api/v2/vendor/${VendorId}/tradeLicense`,
      TradeLicense,
      { params: query }
    );
  }

  deleteTradeLicense(
    VendorId: number,
    query: {
      VendorTradeId?: number;
      LicenseId?: number;
      id?: number;
      PrimaryTradeLicenseRequirementId?: number;
    } = {}
  ): Observable<any> {
    return this.http.delete(`/api/v2/vendor/${VendorId}/tradeLicense`, {
      params: query
    });
  }
}
